import React, { ReactElement, useEffect } from 'react';
import { PageLoadingIndicator } from '@fluentsms/components';
import { useAuth } from '@fluentsms/auth';
import { useHistory, useLocation } from 'react-router-dom';

const Login = (): ReactElement => {
  const { push } = useHistory();
  const location = useLocation();

  const { signIn, isAuthenticated, isSigningOut } = useAuth();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const from = params.get('from');

    if (!isAuthenticated() && !isSigningOut) signIn();
    if (!isSigningOut) push(from ?? '/');
  }, [isAuthenticated, isSigningOut, location.search, push, signIn]);

  return <PageLoadingIndicator />;
};

export default Login;
